import { render } from "./LineChartN.vue?vue&type=template&id=2933b47d&scoped=true"
import script from "./LineChartN.vue?vue&type=script&lang=ts"
export * from "./LineChartN.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-2933b47d"

export default script